// Vollea — Edit Profile
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import { Btn } from "../components/ui-vollea";
import { api } from "../lib/api";
import { C, SP, R } from "../lib/theme";

export default function EditProfile() {
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/profile/me").then(setP).catch(() => {});
  }, []);

  const upd = (k) => (e) => setP((prev) => ({ ...prev, [k]: e.target.value }));

  const save = async (e) => {
    e?.preventDefault?.();
    setSaving(true); setMsg("");
    try {
      const body = {
        name: p.name, gender: p.gender, location: p.location,
        playing_side: p.playing_side, preferred_hand: p.preferred_hand,
        skill_level: p.skill_level, bio: p.bio,
        is_public: p.is_public,
      };
      await api.put("/profile/me", body);
      setMsg("Profile saved");
      setTimeout(() => navigate(-1), 600);
    } catch (e) { setMsg(e.message); }
    finally { setSaving(false); }
  };

  const label = { color: C.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: 1, marginBottom: 6, marginTop: SP.md, textTransform: "uppercase", display: "block" };
  const input = { width: "100%", background: C.surface, borderRadius: R.md, border: `1px solid ${C.border}`, color: C.text, padding: `0 ${SP.lg}px`, height: 52, fontSize: 15, outline: "none" };
  const textarea = { ...input, height: 100, padding: SP.lg, resize: "vertical" };

  if (!p) return <div style={{ padding: SP.xl, textAlign: "center", color: C.lime }}>Loading…</div>;

  return (
    <form onSubmit={save} style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 40px` }}>
      <button type="button" onClick={() => navigate(-1)} data-testid="edit-profile-back" style={{ color: C.text, marginBottom: SP.md }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Edit profile</h1>

      <label style={label}>Name</label>
      <input data-testid="edit-profile-name" style={input} value={p.name || ""} onChange={upd("name")} />

      <label style={label}>Location</label>
      <input data-testid="edit-profile-location" style={input} value={p.location || ""} onChange={upd("location")} placeholder="City, country" />

      <label style={label}>Gender</label>
      <select data-testid="edit-profile-gender" style={input} value={p.gender || ""} onChange={upd("gender")}>
        <option value="">Prefer not to say</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>

      <label style={label}>Skill level</label>
      <select data-testid="edit-profile-skill" style={input} value={p.skill_level || "beginner"} onChange={upd("skill_level")}>
        <option value="beginner">Beginner</option>
        <option value="intermediate">Intermediate</option>
        <option value="advanced">Advanced</option>
        <option value="pro">Pro</option>
      </select>

      <label style={label}>Playing side</label>
      <select data-testid="edit-profile-side" style={input} value={p.playing_side || "both"} onChange={upd("playing_side")}>
        <option value="left">Left</option>
        <option value="right">Right</option>
        <option value="both">Both</option>
      </select>

      <label style={label}>Preferred hand</label>
      <select data-testid="edit-profile-hand" style={input} value={p.preferred_hand || "right"} onChange={upd("preferred_hand")}>
        <option value="left">Left</option>
        <option value="right">Right</option>
      </select>

      <label style={label}>Bio</label>
      <textarea data-testid="edit-profile-bio" style={textarea} value={p.bio || ""} onChange={upd("bio")} placeholder="Tell other players a bit about you…" />

      <label style={label}>Profile visibility</label>
      <select
        data-testid="edit-profile-visibility"
        style={input}
        value={p.is_public ? "public" : "private"}
        onChange={(e) => setP({ ...p, is_public: e.target.value === "public" })}
      >
        <option value="public">Public</option>
        <option value="private">Private</option>
      </select>

      {msg ? <p data-testid="edit-profile-msg" style={{ color: msg === "Profile saved" ? C.lime : C.error, marginTop: SP.md, fontSize: 13 }}>{msg}</p> : null}

      <div style={{ height: SP.lg }} />
      <Btn label="Save changes" loading={saving} testid="edit-profile-save" type="submit" onClick={save} />
    </form>
  );
}
